<template>
  <Dropdown
    v-model="selectedPodcaster"
    :options="podcastersList"
    option-label="email"
    option-value="podcaster_id"
    placeholder="All Podcasters"
    class="tw-border-none tw-outline-none tw-shadow-none tw-bg-none tw-bg-transparent tw-items-center tw-max-w-full sm:tw-max-w-96"
    input-class="tw-text-3xl md:tw-text-[40px] tw-font-black tw-p-0 tw-leading-normal tw-font-heading"
    panel-class="tw-max-w-xs md:tw-max-w-sm lg:tw-max-w-lg xl:tw-max-w-2xl"
    filter
    @change="emits('selectPodcaster', selectedPodcaster)"
  >
  </Dropdown>
</template>

<script setup>
import Dropdown from "primevue/dropdown";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

const emits = defineEmits(["selectPodcaster"]);

const store = useStore();

const token = localStorage.getItem("podcastAdminToken");

const podcastersList = computed(() => {
  let tempPodcasters = store.getters.podcasters;
  if (!tempPodcasters) {
    tempPodcasters = [];
  }
  tempPodcasters = tempPodcasters.map((item) => ({ ...item }));
  tempPodcasters.unshift({
    email: "All Podcasters",
    podcaster_id: "podcastAdmin",
  });
  return tempPodcasters;
});
const selectedPodcaster = ref("podcastAdmin");

const fetchPodcasters = () => {
  store.dispatch("loadPodcasters", {
    token,
    fields: ["podcaster_id", "name", "email"],
  });
};

onMounted(() => {
  fetchPodcasters();
});
</script>
